export default "__VITE_ASSET__C7V14wns__"